import { render, staticRenderFns } from "./DeliverableFees.vue?vue&type=template&id=31b0745a&scoped=true&"
import script from "./DeliverableFees.vue?vue&type=script&lang=js&"
export * from "./DeliverableFees.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableFees.vue?vue&type=style&index=0&id=31b0745a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0745a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VSwitch,VTextField})
